<template>
  <div class="elite-content_sidebar_level2">
    <div class="elite-content_sidebar_level2_inner">
      <h2>{{ $t("APPS.SALES_MODULE") }}</h2>
      <ul class="sub-menu-items">
        <li v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_SALES_ORDERS)">
          <router-link
            :to="{ name: 'List SalesOrders' }"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="{ 'active-link': isActive }"
            >
              <span class="text">
                {{ $t("COMMON.SALES_ORDERS") }}
              </span>
            </a>
          </router-link>
        </li>
        <li
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_SALES_INVOICES)"
        >
          <router-link
            :to="{ name: 'List SalesInvoices' }"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="{ 'active-link': isActive }"
            >
              <span class="text">
                {{ $t("COMMON.SALES_INVOICES") }}
              </span>
            </a>
          </router-link>
        </li>
        <li
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_SALES_PAYMENTS)"
        >
          <router-link
            :to="{ name: 'List SalesPayments' }"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="{ 'active-link': isActive }"
            >
              <span class="text">
                {{ $t("COMMON.SALES_PAYMENTS") }}
              </span>
            </a>
          </router-link>
        </li>
        <li
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_SALES_DELIVERIES)"
        >
          <router-link
            :to="{ name: 'List SalesDeliveries' }"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="{ 'active-link': isActive }"
            >
              <span class="text">
                {{ $t("COMMON.SALES_DELIVERIES") }}
              </span>
            </a>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moduleLayoutMixin from "@/mixins/module-layout-mixin";

export default {
  components: {},

  mixins: [moduleLayoutMixin],

  data() {
    return {};
  },

  methods: {},

  async mounted() {},

  computed: {},

  watch: {},
};
</script>
